module.exports = __webpack_public_path__ + "assets/img/save-code-text.2db8774e.png";